<script setup>
import { store } from '@/store/appStore.js'
const oos = store.scmV2.oos
</script>

<template>
  <div>
    <div class="card module-header"><h2>{{ oos.length }} SKU(s) currently out of stock</h2></div>
    <div v-for="s in oos" :key="s.productSku+s.warehouse" class="card oos-card">
      <div class="oos-card-top">
        <div><h4>{{ s.productName }} <span class="cell-muted">({{ s.productSku }})</span></h4><div class="cell-muted">{{ s.warehouse }}</div></div>
        <span class="tier-badge" style="background:var(--status-red-bg);color:var(--status-red);">OOS · {{ s.oosDuration }} days</span>
      </div>
      <div class="oos-meta-grid">
        <div><div class="label">OOS Date</div>{{ s.oosDate }}</div>
        <div><div class="label">Expected Replenishment</div>{{ s.replenishmentDate }}</div>
        <div><div class="label">Impacted Pharmacies</div>{{ s.impactedPharmacies.length }}</div>
      </div>
      <div class="impacted-chip-list"><span v-for="n in s.impactedPharmacies" :key="n" class="impacted-chip">{{ n }}</span></div>
    </div>
  </div>
</template>
